import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Button from "@material-ui/core/Button";

 const TableSiteTop = ({headlineText, handleModalOpen, role, roleOverride, isButtonDisabled}) => {
  return (
    
    <Grid container spacing={8} direction="row" justify="space-between" alignItems="flex-end">
      <Grid item xs={8} md={3} lg={1}> 
        <Typography variant="headline">{headlineText}</Typography>
      </Grid>
      <Grid item >
        {(role === "admin" || roleOverride) && <Button 
          variant="contained" 
          color="primary" 
          onClick={ handleModalOpen }
          disabled={isButtonDisabled}>
          Add
        </Button>}
      </Grid>
    </Grid>
  )
}

export default TableSiteTop;


// WEBPACK FOOTER //
// ./src/components/Tables/TableSiteTop.js